var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSnsRakutenRoomFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.79 2c4.999.13 9.077 4.139 9.077 9.118 0 4.139-2.763 7.566-6.578 8.73 1.316 1.746 3.224 3.62 5.395 4.203 1.052.323 2.105.258 3.223-.195.592.97 1.316 1.876 2.237 2.652.592.646 1.25 1.164 1.973 1.681-2.04 1.23-4.145 1.811-6.25 1.811-.92 0-1.973-.13-2.894-.388-5.329-1.422-9.078-6.401-10.394-8.665v7.63H3V2h10.79zM9.58 7.238v7.113h3.683c1.907 0 3.355-1.552 3.42-3.492 0-1.81-1.25-3.62-3.158-3.62H9.58z",
    fill: "#C61E79"
  })));
}

export default SvgIconSnsRakutenRoomFilled;